module.exports = __webpack_public_path__ + "img/thumbnail_SlothBear_f_normal.33ccf8c9.png";